import { render } from "./LayoutLanding.vue?vue&type=template&id=4030e208&scoped=true"
const script = {}

import "./LayoutLanding.vue?vue&type=style&index=0&id=4030e208&lang=scss"
import "./LayoutLanding.vue?vue&type=style&index=1&id=4030e208&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4030e208"]])

export default __exports__